// extracted by mini-css-extract-plugin
module.exports = {"casinoIFrame":"_6706b79"};